const normalizeQuantityDefaultSource = (source) => {
  if (typeof source !== "string") {
    return source;
  }

  return source.trim();
};

const parsePositiveInteger = (value) => {
  const parsedValue = Number.parseInt(value, 10);

  if (!Number.isNaN(parsedValue) && parsedValue > 0) {
    return parsedValue;
  }

  return undefined;
};

export const resolveStaticDefaultQuantity = (options = {}) => {
  const source = normalizeQuantityDefaultSource(options["quantity-default-source"]);

  if (source && source !== "static") {
    return undefined;
  }

  return parsePositiveInteger(options["quantity-default-static-value"]);
};
